module.exports = __webpack_public_path__ + "img/prevencao_01.ae918308.png";